export default "__VITE_ASSET__D1B$dHUb__"